import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';
import { useProfessionalInitialRouteData } from '@modules/professional/hook/use-professional-initial-route-data';

/**
 * Click handler for the professional's own links inside their CMS copy.
 *
 * The profile's sibling of the product and project hooks. A professional's
 * About copy is the densest user-written text on the site — brand names, award
 * certificates, sub-sites — and every one of those links goes out to them, so
 * it has to arrive saying where it came from, the same as the Visit Website
 * button above it.
 *
 * The reader's own id (`__apid`) is attached here on the click because it is
 * only known in the browser and names them; the UTM parameters are in the
 * markup, which is what makes a copied or middle-clicked link carry the
 * referral too.
 */
export const useProfessionalLinkTracking = () => {
    const professional = useProfessionalInitialRouteData();

    return useWebsiteTrackingProxy(
        {
            professionalID: professional.ID,
            professionalTitle: professional.Title,
            itemType: 'Professional',
            link: professional.Link,
        },
        {
            attachUTM: true,
            processRelativeURL: true,
        },
    );
};
